import React, { useState } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import useLang from '../../../hooks/useLang';
const OptionsField = (props) => {
    const lang = useLang();
    let option = props.options;
    let optionsList = option.accepted_values.split(',');
    const selectOptions = optionsList.map((o) => { return { label: o, value: o } });
    const [optionValue, setOptionValue] = useState();
    return (
        <Select
            options={selectOptions}
            placeholder={lang === "en" ? option.name : option.name_ar}
            styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    padding: 5,
                    borderRadius: 30,
                    marginBottom: 20,
                    width: "100%"
                }),
            }}
            value={optionValue}
            onChange={(e) => {
                setOptionValue(e);
                props.onChange(e);
            }}
        />
    );
}
OptionsField.propTypes = {
    options: PropTypes.object.isRequired,
    onChange:PropTypes.func.isRequired
}
export default OptionsField;